export let messages = {
    disposition: 'Dispozice',
    accessory:   'Příslušenství',
    designation: 'Jednotka',
    phase:       'Etapa',
    building:    'Budova',
    price:       'Cena',
    type:        'Typ',
    status:      'Status',
    floorNumber: 'Patro',
    floorArea:   'Plocha',
    orientation: 'Orientace',
    link:        'Odkaz',
    sortable:    'Řaditelný',
    cardFile:    'Karta bytu',
    interest:    'Formulář zájmu'
}
